'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getEarlyRequesterResultPromise from '../earlyRequester/getEarlyRequesterResultPromise';

const getScopesURI = portalId => `hubs2/v1/scopes/hub/${portalId}/filter`;

export default class PortalSettingsApi {
  static fetchPortalScopes() {
    return getEarlyRequesterResultPromise({
      name: 'initial-portal-scopes-fetch',
      retryRequester: () => http.get(getScopesURI(PortalIdParser.get()), {
        query: {
          scopes: ['landingpages-access', 'sitepages-access', 'blog-access', 'landingpages-schedule', 'pages-schedule', 'blog-schedule', 'content-ab-testing', 'content-mab-testing', 'landingpages-custom-domain-access', 'website-pages-no-branding', 'landingpages-no-branding', 'blog-pages-no-branding', 'ads-roi-reporting']
        }
      }),
      wrapInObservable: false
    });
  }

}